import React, { useMemo } from 'react';

import { RadioCard } from '../../../../common/components/RadioCard';
import { useScannedRelevosContext } from '../../../../contexts/ScannedRelevosContext';
import { useRestaurantsData } from '../../../../services/restaurants';
import { ScannerMode } from '../../model/enums/scanner-mode.enum';
import { ItemAssignmentSelectMode } from '../UserSelect/types';

type SelectAssignmentModeProps = {
  bgColor?: string;
};

export const SelectAssignmentMode = ({ bgColor }: SelectAssignmentModeProps) => {
  const { selectItemMode, setSelectItemMode, mode } = useScannedRelevosContext();
  const { isQuickContactsEnabled } = useRestaurantsData();

  const options = useMemo(() => {
    if (mode === ScannerMode.RETURN) {
      return isQuickContactsEnabled
        ? Object.values(ItemAssignmentSelectMode)
        : [ItemAssignmentSelectMode.CAMERA_SCAN, ItemAssignmentSelectMode.HAND_SCANNER_SCAN];
    }
    return Object.values(ItemAssignmentSelectMode);
  }, [isQuickContactsEnabled, mode]);

  return (
    <RadioCard
      options={options}
      name="AssignMode"
      defaultValue={selectItemMode}
      onChange={setSelectItemMode}
      bgColor={bgColor}
    />
  );
};
